export default "__VITE_ASSET__faf7fc30__"